<script setup>
/*
=========================================================
* Vue Material Kit 2 - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vue-material-kit
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

==========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { onMounted } from "vue"
import { RouterView } from "vue-router"
//import CookieConsent from "@/components/CookieConsent.vue"

onMounted(() => {
  // Script para anuncios Google Ads si el usuario dio consentimiento
  /*if (localStorage.getItem("cookieConsent") === "all") {
    const adsScript = document.createElement("script")
    adsScript.async = true
    adsScript.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8335154798852284"
    adsScript.setAttribute("crossorigin", "anonymous")
    document.head.appendChild(adsScript)
  }*/

  // Insertar JSON-LD para organización en el head
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "sits",
    "email": "mailto:contacto@stageisthestreet.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Bizkaia",
      "addressCountry": "ES"
    },
    "url": "https://stageisthestreet.com",
    "description": "Organización dedicada a eventos",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "mailto:contacto@stageisthestreet.com"
    },
    "category": "Eventos"
  }

  const ldScript = document.createElement("script")
  ldScript.type = "application/ld+json"
  ldScript.text = JSON.stringify(jsonLd)
  document.head.appendChild(ldScript)
})
</script>

<template>
  <RouterView />
  <!--<CookieConsent />-->
</template>
<style>
.page-content {

  min-height: calc(100vh - 78px); /* Ajusta según la altura del footer */
}</style>